import recipientApi from "@/api/recipients";


const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    recipients: null,
}

export const mutationTypes = {
    clearRecipients: '[recipients] clearRecipients',
    appendRecipients: '[recipients] appendRecipients',
    setIsLoading: '[recipients] setIsLoading',
    setIsMore: '[recipients] setIsMore',
    setNextPage: '[recipients] setNextPage'
}

export const actionTypes = {
    getRecipients: '[recipients] getRecipients',
    removeRecipient: '[recipients] removeRecipients',
    createRecipient: '[recipient] createRecipient',
    updateRecipient: '[recipient] updateRecipient'
}

export const getterTypes = {
    recipients: '[recipients] recipients',
    isLoading: '[recipients] isLoading',
    isMore: '[recipients] isMore'
}

const mutations = {
    [mutationTypes.appendRecipients](state, recipients) {
        if (state.recipients === null){
            const arrProxy = new Proxy(recipients, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.recipients = arrProxy
        } else {
            recipients.forEach((recipient) => {
                const found = state.recipients.find((element) => element.id === recipient.id);
                if (!found){
                    state.recipients.push(recipient)
                }
            })
        }
    },
    [mutationTypes.clearRecipients](state){
        state.recipients = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    }
}

const getters = {
    [getterTypes.recipients]: state => {
        return state.recipients
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const actions = {
    [actionTypes.getRecipients](context) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            recipientApi
                .getRecipients(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendRecipients, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.removeRecipient](context, credentials) {
        console.log('removeRecipient')
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            recipientApi
                .removeRecipient(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.createRecipient](context, credentials) {
        console.log('createRecipient')
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            recipientApi
                .createRecipient(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                    resolve(result.response)
                })
        })
    },
    [actionTypes.updateRecipient](context, credentials) {
        console.log('updateRecipient')
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            recipientApi
                .updateRecipient(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}